import React from 'react'

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="text-center">
        {/* OVACS Logo Placeholder */}
        <div className="mb-6">
          <div className="w-16 h-16 mx-auto bg-gradient-to-br from-brand-primary to-brand-hover rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xl">O</span>
          </div>
        </div>
        
        {/* Loading Spinner */}
        <div className="loading-spinner mx-auto mb-4"></div>
        
        {/* Loading Message */}
        <p className="text-gray-600 font-medium">{message}</p>
      </div>
    </div>
  )
}

export default LoadingScreen
